var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaderboardIconClicked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 8.125C0.5 7.08947 1.24619 6.25 2.16667 6.25H5.5V17.5H0.5V8.125Z",
    fill: "#6A84C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 8.125C0.5 7.08947 1.24619 6.25 2.16667 6.25H5.5V17.5H0.5V8.125Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 10H18.8333C19.7538 10 20.5 10.8395 20.5 11.875V17.5H15.5V10Z",
    fill: "#6A84C5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 10H18.8333C19.7538 10 20.5 10.8395 20.5 11.875V17.5H15.5V10Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16667 4.375C7.16667 3.33947 7.91286 2.5 8.83333 2.5H12.1667C13.0871 2.5 13.8333 3.33947 13.8333 4.375V17.5H7.16667V4.375Z",
    fill: "#6A84C5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16667 4.375C7.16667 3.33947 7.91286 2.5 8.83333 2.5H12.1667C13.0871 2.5 13.8333 3.33947 13.8333 4.375V17.5H7.16667V4.375Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboardIconClicked);
export default __webpack_public_path__ + "static/media/leaderboard-icon-clicked.ece378ed4553090e1c9438448ce7ce59.svg";
export { ForwardRef as ReactComponent };